import { Text } from '@sitecore-jss/sitecore-jss-react';
import React, { FC } from 'react';
import eventTypes from '../../../../enums/Event.enums';
import { TStringField } from '../../../../types/types';
import { TNavigationTabsMobileProps } from '../types/navigationBar.types';

const NavigationTabsMobile: FC<TNavigationTabsMobileProps> = (props) => {
  const { sticky, activeTab, isEditorial, tabs, scrollToPlaceholder, clickPageNavEvent } = props;
  return (
    <ul className={`navigation-bar-mobile ${sticky ? 'sticky-element--hide' : ''}`}>
      {tabs?.map((tab, index) => (
        <li
          role={'listitem'}
          className={`navigation-bar-mobile__tab ${activeTab === index ? 'navigation-bar-mobile__tab--active' : ''} ${
            !tab.isVisible ? 'navigation-bar-mobile__tab--hidden' : ''
          }`}
          key={index}
          onClick={() => {
            scrollToPlaceholder(index);
            clickPageNavEvent(eventTypes.navEvent, isEditorial ? (tab?.label as TStringField)?.value : (tab?.label as string), index + 1);
          }}
        >
          <Text
            tag="div"
            field={isEditorial ? (tab?.label as TStringField) : ({ value: tab?.label } as TStringField)}
            editable={isEditorial}
          />
        </li>
      ))}
    </ul>
  );
};

export default NavigationTabsMobile;
